module.exports = __webpack_public_path__ + "static/media/twsFooter.47b14eb6.png";